import React from "react";
import { Box, Text } from "@mantine/core";

export function Amstaff() {
    return (
        <Box sx={{
            position: 'absolute',
            top: '6rem',
        }}>
            <Text className="vertical-text">
                AMSTAFF
            </Text>
        </Box>
    );
}